<template></template>

<script>
import { createNamespacedHelpers } from "vuex";
import store from "@/lib/store";
import {
  customerNotAnsweredNotification,
  repNotAnsweredNotification,
} from "./notifications";

const { mapState } = createNamespacedHelpers("conference");

export default {
  props: ["channel"],
  data() {
    return {
      user: store.get("user"),
    };
  },
  computed: mapState(["activity"]),
  created() {
    this.channel.bind("connection.no-answer", ({ participant }) => {
      if (participant.userId === this.user.id) {
        repNotAnsweredNotification({
          phoneNumber: this.activity.from.internationalPhoneNumber,
        }).show();
      } else if (!participant.isGhost) {
        // Customer
        customerNotAnsweredNotification().show();
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// connection-no-answer.vue?25ef4e18